import React, { createContext, useContext, useState, useEffect } from 'react';
import { applyCSSVariables } from './colors';

// Create the context
const ThemeContext = createContext();

// Custom hook to use the theme context
export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}

// Theme provider component
export function ThemeProvider({ children }) {
  // Remove all dark mode logic, always use light theme, remove darkMode state and toggleDarkMode, always set theme-light class and applyCSSVariables(false)

  // Get current theme colors (for JavaScript access)
  const getColor = (path) => {
    const cssVar = `--color-${path.replace('.', '-')}`;
    return getComputedStyle(document.documentElement).getPropertyValue(cssVar).trim();
  };

  // Context value
  const value = {
    getColor,
    // Helper functions for common colors
    colors: {
      primary: () => getColor('primary'),
      background: () => getColor('background'),
      surface: () => getColor('surface'),
      textPrimary: () => getColor('text-primary'),
      textSecondary: () => getColor('text-secondary'),
    }
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}
